import PropTypes from 'prop-types';
import ExtraPropTypes from 'react-extra-prop-types';

export default PropTypes.shape({
  app: ExtraPropTypes.uuid.isRequired,
  user: ExtraPropTypes.uuid.isRequired,
  image: ExtraPropTypes.uuid,

  review: PropTypes.string,
  rating: PropTypes.number,
  ratingApproved: PropTypes.number,
});
